import React, { useEffect, useState } from "react";
import "../../pages/cart/cart.css";
import "./wishlist.css";
import DeleteIcon from "@mui/icons-material/Delete";
import Header from "../../components/header/Header";
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";
import { baseURL } from "../../constants/url";
import Swal from "sweetalert2";

import { useWishlist } from "../../context/WishlistContext";

const Wishlist = () => {
  const [wishlistItems, setWishlistItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const { fetchWishlistCount } = useWishlist();  

  const fetchWishlist = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) return;

      const response = await fetch(`${baseURL}common/wishlist`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (data && Array.isArray(data.results)) {
        setWishlistItems(data.results);
      } else {
        console.warn("Unexpected wishlist response", data);
      }
    } catch (error) {
      console.error("Error fetching wishlist:", error);
    }
  };

  useEffect(() => {
    fetchWishlist();
  }, []);

  const handleRemoveFromWishlist = async (productId) => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) return;

      await fetch(`${baseURL}common/wishlist_toggle/${productId}/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "Product removed from wishlist.",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
      });

      //  Refresh both list and counter
      fetchWishlist();
      fetchWishlistCount(); // this updates header count
    } catch (error) {
      console.error("Error removing from wishlist:", error);
    }
  };

  const totalPages = Math.ceil(wishlistItems.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = wishlistItems.slice(indexOfFirstItem, indexOfLastItem);

  const renderPagination = () => (
    <div className="pagination-wrapper">
      <button
        disabled={currentPage === 1}
        onClick={() => setCurrentPage((prev) => prev - 1)}
        className="pagination_btn"
      >
        Previous
      </button>

      <span style={{ margin: "0 10px" }}>
        Page {currentPage} of {totalPages}
      </span>

      <button
        disabled={currentPage === totalPages}
        onClick={() => setCurrentPage((prev) => prev + 1)}
        className="pagination_btn"
      >
        Next
      </button>
    </div>
  );

  return (
    <>
      <Header />
      <div className="bg_gray">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="pt_20 pb_30">
                <div className="heading_common mt_15">
                  <h3>My Wishlist Item</h3>
                </div>
                <div className="table-responsive cart_box bg_white_g mb_20">
                  <table className="widthFull cart_table table">
                    <thead>
                      <tr>
                        <th>Product Image</th>
                        <th>Product Name</th>
                        <th>Price</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length === 0 ? (
                        <tr>
                          <td colSpan="6" style={{ textAlign: "center" }}>
                            Your wishlist is empty.
                          </td>
                        </tr>
                      ) : (
                        currentItems.map((item) => {
                          const product = item.product;
                          const imageUrl =
                            product.images.length > 0
                              ? product.images[0].image
                              : "/placeholder.png";

                          return (
                            <tr key={item.id}>
                              <td>
                                <div className="cart-image">
                                  <img
                                    src={imageUrl}
                                    alt={product.name}
                                    style={{
                                      width: "80px",
                                      height: "45px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                              </td>
                              <td>
                                <strong>{product.name}</strong>
                                <p>Size: {product.size || "N/A"}</p>
                              </td>
                              <td>₹ {product.final_price}</td>
                              <td>
                                <button
                                  type="button"
                                  className="delete_btn"
                                  onClick={() =>
                                    handleRemoveFromWishlist(product.id)
                                  }
                                >
                                  <DeleteIcon className="color_red" />
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>

                {wishlistItems.length > itemsPerPage && renderPagination()}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Subscribe />
      <Footer />
    </>
  );
};

export default Wishlist;
